import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  pure: true
})
export class OrderByPipe implements PipeTransform {

  transform(value: any[], propertyName: string): any[] {
    if (propertyName){
    console.log("b[propertyName]");
    console.log(propertyName);
  // var a=value.sort((a: any, b: any) => b[propertyName].localeCompare(a[propertyName]));
  if(value){
  var a=value.sort((a: any, b: any) => a[propertyName].localeCompare(b[propertyName]));
 console.log("sorting data");
    console.log(a);
      return a 
}
   
    }
    else{
      return value;
  }

}
}